import axios, { create } from 'axios';
import getBaseURL from './getBaseURL';

const timeout = 600000;

/** @type {import('axios').AxiosInstance} */
const axiosInstance = create({ baseURL: getBaseURL(), timeout });
const defaultErrorInterceptor = error => Promise.reject(error);
const defaultRequestInterceptor = config => config;
const defaultResponseInterceptor = response => response;

export function setHeader(key, value) {
  axiosInstance.defaults.headers.common[key] = value;
}

export function unsetHeader(key) {
  delete axiosInstance.defaults.headers.common[key];
}

export function addRequestInterceptor({ request, error }) {
  const interceptor = axiosInstance.interceptors.request.use(
    request || defaultRequestInterceptor,
    error || defaultErrorInterceptor
  );
  return () => {
    axiosInstance.interceptors.request.eject(interceptor);
  };
}

export function addResponseInterceptor({ response, error }) {
  const interceptor = axiosInstance.interceptors.response.use(
    response || defaultResponseInterceptor,
    error || defaultErrorInterceptor
  );
  return () => {
    axiosInstance.interceptors.response.eject(interceptor);
  };
}

/**
 * @return {Promise<any>}
 */
const get = (url, config) => {
  return axiosInstance.get(url, config).then(response => response.data);
};

const post = (url, data, config) => {
  return axiosInstance.post(url, data, config).then(response => response.data);
};

const client = {
  get,
  post,
  postRaw: axiosInstance.post,
  getRaw: axiosInstance.get,
  delete: axiosInstance.delete,
  put: axiosInstance.put,
  patch: axiosInstance.patch,
  request: axiosInstance.request,
  getCancelToken: axios.CancelToken.source,
};

export default client;
